import React from "react";
import Checkbox from "../Checkbox";
import { createColumnHelper } from "@tanstack/react-table";

const columnHelper = createColumnHelper();

const useCheckboxColumn = () => {
    return columnHelper.display({
        id: "select",
        enableSorting: false,
        width: "7.5%",
        header: ({ table }) => (
            <Checkbox
                value={table.getIsAllPageRowsSelected()}
                intermediate={table.getIsSomePageRowsSelected()}
                onChange={(isChecked) =>
                    table.getToggleAllPageRowsSelectedHandler()({ target: { checked: isChecked } })
                }
                small
                style={{ margin: "auto" }}
            />
        ),
        cell: ({ row }) => (
            <Checkbox
                value={row.getIsSelected()}
                disabled={!row.getCanSelect()}
                onChange={(isChecked) => row.getToggleSelectedHandler()({ target: { checked: isChecked } })}
                small
                style={{ margin: "auto" }}
            />
        ),
    });
};

export default useCheckboxColumn;
